import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { getServiceContent } from "@/lib/serviceContent";
import { useCmsDocument } from "@/cms/CmsContentProvider";

// Thin route wrapper: resolves the CMS-ready content for the given service slug
// and renders the single shared template. One template → four pages.
export default function ServiceDetail({ slug }) {
  useCmsDocument();
  const content = getServiceContent(slug);
  if (!content) return null;
  return <ServicePageTemplate content={content} />;
}
